<template>
  <v-form v-model="valid" lazy-validation ref="form" id="new-form">
    <v-card>
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col cols="6" sm="6" md="1" xs="6">
              <v-text-field
                  filled
                  v-model="this.$route.query.purchaseid"
                  disabled
                  readonly
                  label="Order ID"
              ></v-text-field>
            </v-col>

            <v-col cols="6" sm="6" md="3">
              <v-select
                  filled
                  :items="providers"
                  v-model="providerid"
                  required
                  label="Provider"
              ></v-select>
            </v-col>

            <v-col cols="6" sm="6" md="3">
              <v-text-field
                  filled
                  v-model="total"
                  required
                  :rules="priceRules"
                  label="Total amount (USD)"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2" xs="6">
              <v-file-input
                  filled
                  v-model="invoice"
                  accept="image/*"
                  label="Invoice File"
              ></v-file-input>
            </v-col>

            <v-col cols="4" sm="4" md="2">
              <v-switch
                  dense
                  v-model="paid"
                  label="Paid ?"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-sheet
                  class="flex-fill pb-4"
                  color="#f9f9f9"
                  outline
                  elevation="1"
              >
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th>Category</th>
                      <th>Part</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                    </tr>
                    </thead>
                    <tbody v-if="gotcats">
                    <tr v-for="index in rows" :key="index">
                      <td class="align-center">
                        <v-autocomplete
                            dense
                            :items="cats"
                            v-model="selectedparts[index - 1].id"
                            @change="
                                  getParts(
                                    selectedparts[index - 1].id,
                                    index - 1
                                  )
                                "
                        >
                        </v-autocomplete>
                      </td>
                      <td>
                        <v-autocomplete
                            dense
                            :items="selectedparts[index - 1].parts"
                            v-model="selectedparts[index - 1].selected"
                        ></v-autocomplete>
                      </td>
                      <td>
                        <v-text-field
                            dense
                            v-model="selectedparts[index - 1].quan"
                            type="number"
                        />
                      </td>
                      <td>
                        <v-text-field
                            dense
                            v-model="selectedparts[index - 1].unitprice"
                            type="number"
                        />
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-simple-table>
                  <template>
                    <tfoot>
                    <tr>
                      <td>
                        <v-btn
                            color="blue"
                            @click="addMore()"
                            class="white--text"
                        >
                          <v-icon dark class="me-2">mdi-plus</v-icon>
                          Add more rows
                        </v-btn>
                      </td>
                    </tr>
                    </tfoot>
                  </template>
                </v-simple-table>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn
            color="primary darken-1"
            dark
            form="new-form"
            @click="validate"
            :disabled="!valid"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { __HTTP, FormHeader, UploadHeader, __HAS_PERM } from "@/utils/utils";

export default {
  name: "EditPurchase",
  computed: {
    grandtotal() {
      let index = this.shippingtypes.findIndex(
          o => o.value == this.shippingtype.value
      );
      var xxx = 0;
      if (this.invoicetype == "pc") {
        //console.log(this.shippingtypes);
        //console.log("Types",this.shippingtypes[index]);
        xxx =
            parseInt(this.total == "" ? 0 : this.total) -
            parseInt(this.discount == "" ? 0 : this.discount) +
            parseInt(this.shippingtypes[index].price);
      } else {
        var total = 0;
        this.selectedparts.forEach(el => {
          if (el.selected != null) {
            // console.log(el);
            total += parseInt(el.quan * el.unitprice);
          }
        });
        //this.total = total;
        xxx =
            total -
            parseInt(this.discount == "" ? 0 : this.discount) +
            parseInt(this.shippingtypes[index].price);
      }
      return xxx;
    }
  },
  components: {},
  watch: {
    options: {
      handler() {
        this.getList()
      }
    }
  },
  methods: {
    addMore() {
      this.selectedparts.push({
        id: null,
        parts: [],
        selected: null,
        quan: 1,
        unitprice: 0
      });
      this.rows++;
    },
   getParts: function(val, i) {
      __HTTP("?do=getparts", JSON.stringify({ id: val }), FormHeader, res => {
        this.selectedparts[i].parts = res;
        this.selectedparts[i].price = res[0].cost;
      });
    },
    getPurchase() {
      __HTTP("?do=getpurchase", JSON.stringify({id: this.$route.query.purchaseid}), FormHeader, res => {
        console.log(res);
          this.cats = res.cats;
          this.gotcats = true;
          this.providers = res.providers;
         
          this.providerid = res.providerid;
          this.total = res.total;
          this.paid = res.paid == "0" ? "" : "1";
          this.rows = res.items.length;
          res.items.forEach(e => {
              this.selectedparts.push({
                id: e.catid,
                parts: e.parts,
                selected: e.item,
                quan: e.quan,
                unitprice: e.unitprice
              });
            });
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.insertNewItem();
      }
    },
    
    getProviders() {
      this.isloading = true;
      __HTTP(
          "?do=getproviders",
          JSON.stringify({ keyword: "" }),
          FormHeader,
          res => {
            this.isloading = false;
            this.providers = res;
          }
      );
    },
    insertNewItem() {
      var fd = new FormData();
      fd.append("file", this.toBeEdit.invoice);
      var ss = new Array();
      this.selectedparts.forEach(e => {
        if (e.selected != null) {
          ss.push({ id: e.selected, quan: e.quan, unitprice: e.unitprice });
        }
      });
      const vv = JSON.stringify({
        id: this.$route.query.purchaseid,
        providerid: this.providerid,
        total: this.total,
        parts: ss,
        paid: this.paid
      });
      // console.log("Send", vv);
      fd.append("data", vv);
      //console.log(vv);
      __HAS_PERM(37,
          this.$store.state.loggedUser.id,
          () => {
            __HTTP(
                "?do=edit&type=purchases",
                fd,
                UploadHeader,
                res => {
                  //console.log(res);
                  if (res.auth) {
                   this.$router.push({path: '/purchases'});
                  } else {
                    /// error
                    alert("Error while editing");
                  }
                }
            );
          }
      );
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      let c = confirm("Are you sure to remove this record ?");
      if (c) {
        __HAS_PERM(38, this.$store.state.loggedUser.id, () => {
          __HTTP("?do=delete", { type: "purchases", id: item.id }, null, () => {
            this.items.splice(index, 1);
          });
        });
      }
    }
  },
  created() {
    //this.getCats();
    this.getPurchase();
    //this.getProviders();
    //this.getList();
    this.$store.state.title = "Edit Purchase Order";
  },
  data: () => ({
    valid: true,
    gotcats: false,
    cache: {},
    options: {},
    rows: 0,
    cats: [],
    selectedparts: [],
    quan: [],
    unitprice: [],
    providerid: null,
    total: 0,
    toBeEdit: {
      providerid: "",
      total: "",
      invoice: "",
      paid: "",
      isnew: true,
      shown: true
    },
    dialogTitle: "",
    items: [],
    item: [],
    title: "",
    providers: [],
    priceRules: [
      v => !!v || "This field is required",
      v =>
          (v && v.length >= 1) ||
          "Price must be greater equal or greater than 1 digit."
    ]
  })
};
</script>
